import { Outlet, useLocation } from "react-router-dom";
import Breadcrumb from "./components/Breadcrumb";
import SubMenu from "./components/SubMenu";
import classnames from "classnames";
import "./index.less";

const SubLayout = () => {
  const { pathname } = useLocation();

  const hideSideBarList = [
    "/service/orderDetail",
    "/service/announcement/detail",
  ];
  const isHideSideBar = hideSideBarList.indexOf(pathname) > -1;

  return (
    <>
      <Breadcrumb />
      <section className="max-width sub-content-wrapper flex">
        {isHideSideBar ? null : (
          <aside className="sub-content-menu">
            <SubMenu />
          </aside>
        )}
        <aside
          className={classnames("sub-content", {
            hideSideBar: isHideSideBar,
          })}
        >
          <Outlet />
        </aside>
      </section>
    </>
  );
};

export default SubLayout;
